import { render } from "./TextAreaInput.vue?vue&type=template&id=164f4c3d&scoped=true&lang=pug"
import script from "./TextAreaInput.vue?vue&type=script&lang=ts"
export * from "./TextAreaInput.vue?vue&type=script&lang=ts"

import "./TextAreaInput.vue?vue&type=style&index=0&id=164f4c3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-164f4c3d"

export default script